import { useCustomRouter, usePetType } from '@/containers/hooks'
import { useApiCategoriesList } from '@/rest/generated/hooks'
import { decodeId } from '@/utils/utilApi'

export const useBrandCategory = () => {
  const { query } = useCustomRouter()
  const { rootCategoryId, subCategoryId, brandId } = query as {
    rootCategoryId: string
    subCategoryId: string
    brandId: string
  }
  const { getPetType } = usePetType()
  const petType = getPetType()
  const { data: categoryData, isLoading: isCategoryLoading } = useApiCategoriesList(
    { pet_type: petType, brand_id: decodeId(brandId).id },
    { query: { enabled: Boolean(petType && brandId) } }
  )

  const selectedCategoryName = categoryData?.find((rootCategory) => rootCategory.gid === rootCategoryId)?.name
  const subCategories = categoryData?.find((rootCategory) => rootCategory.gid === rootCategoryId)?.children || []
  const selectedSubCategoryName = subCategories?.find((subCategory) => subCategory.gid === subCategoryId)?.name

  return {
    categoryData,
    selectedCategoryName,
    selectedSubCategoryName,
    isCategoryLoading,
  }
}
